<template>
  <div>
    <h3>Players net sessions log conf</h3>

    <template v-if="enabled !== null">
      <p class="mb-3">
        State:
        <span v-if="enabled" style="color:green">{{stateName}}</span>
        <span v-if="!enabled" style="color:red">{{stateName}}</span>
      </p>
      <template v-if="mayManage">
        <b-button v-if="enabled"  @click="save(false)" variant="danger">Turn off</b-button>
        <b-button v-if="!enabled" @click="save(true)"  variant="primary">Turn on</b-button>
      </template>
    </template>

  </div>
</template>

<script>
import auth from '../auth';
import { HTTP } from '../http-common';
import notifier from '../notifier';
import { mayManagePlayersNetSessionsLogging } from '../util';

export default {
  name: 'SystemPlayersNetSessionsLogConf',

  data() {
    return {
      actor: auth.getViewer(),
      enabled: null,
    };
  },

  computed: {
    mayManage() {
      return mayManagePlayersNetSessionsLogging(this.actor.role);
    },

    stateName() {
      switch(this.enabled) {
        case true:  return 'on';
        case false: return 'off';
      }
      return '?';
    },
  },

  created() {
    this.load();
  },

  methods: {
    load() {
      HTTP.get('/players_net_sessions_logging_enabled')
      .then(response => {
        this.enabled = response.data.data;
      })
      .catch(e => {
        notifier.showError(e.response.data, {sender: this});
      });
    },

    save(enabled) {
      const data = new FormData();
      data.append('enabled', enabled);

      HTTP.post('/players_net_sessions_logging_enabled', data)
      .then(() => {
        this.load();
      })
      .catch(e => {
        notifier.showError(e.response.data, {sender: this});
      });
    },
  },
};
</script>
